import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import './styles.css'
import { XMarkIcon } from '@heroicons/react/24/outline'
import Input from '../../../../ui/Input/input'
import { useForm } from 'react-hook-form'
import { BACKEND_URL } from '../../../../../constants/env'

const modalVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, transition: { duration: 0.5 } },
}

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0, transition: { duration: 0.5 } },
}

const DownloadModal = ({ isOpen, onClose, setIsOpen }) => {
  const [submitError, setSubmitError] = React.useState(false)
  const [submitSuccess, setSubmitSuccess] = React.useState(false)

  const handleModalSubmit = async (formData) => {
    try {
      const requestBody = {
        email: formData.email,
        organization: formData.organization,
        reportName: 'NSF Report',
      }

      const response = await fetch(
        `${BACKEND_URL}/api/landing/reports/download`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        }
      )

      if (!response.ok) {
        throw new Error('Error submitting form')
      }

      setSubmitSuccess(true)
    } catch (error) {
      setSubmitError(true)
      return
    }
  }
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm()

  const handleContentClick = (e) => {
    e.stopPropagation()
  }

  const handleFormSubmit = (data) => {
    handleModalSubmit(data)
    reset()
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className='modal-overlay'
          variants={overlayVariants}
          initial='hidden'
          animate='visible'
          exit='exit'
          onClick={onClose}
          transition={{ duration: 0.2 }}
        >
          <motion.form
            className='modal-content'
            variants={modalVariants}
            initial='hidden'
            animate='visible'
            exit='exit'
            onClick={handleContentClick}
            transition={{ duration: 0.2, delay: 0.1 }}
            onSubmit={handleSubmit(handleFormSubmit)}
          >
            <button
              type='button'
              className='modal-close-button'
              onClick={onClose}
              aria-label='Close modal'
            >
              <XMarkIcon className='modal-close-icon' />
            </button>

            <h2 className='modal-title'>Download Report</h2>

            {submitSuccess ? (
              <button
                onClick={onClose}
                className='nsf-button'
              >
                <a
                  href={process.env.PUBLIC_URL + '/assets/reports/nsf/nsf.pdf'}
                  download='Unlocking Workforce Intelligence'
                  className='download-link'
                >
                  Download Report
                </a>
              </button>
            ) : (
              <>
                <Input
                  id='organization'
                  type='text'
                  required={true}
                  label='Organization'
                  register={register}
                  validation={{ required: 'Organization is required' }}
                  errors={errors}
                  watch={watch}
                />
                <Input
                  id='email'
                  type='email'
                  required={true}
                  label='Email'
                  register={register}
                  errors={errors}
                  watch={watch}
                />

                {submitError && (
                  <p className='error-message'>
                    An error occurred while submitting the form. Please try
                    again.
                  </p>
                )}

                <button
                  type='submit'
                  className='nsf-button modal-download-button'
                >
                  Get Access
                </button>
              </>
            )}
          </motion.form>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default DownloadModal
